export type PartialObject<T> = {
  [K in keyof T]?: T[K] extends Array<infer R>
  ? Array<PartialObject<R>>
  : T[K] extends ReadonlyArray<infer R>
  ? ReadonlyArray<PartialObject<R>>
  : PartialObject<T[K]>;
};

const isPlainObject = <T extends object>(value: T | unknown): boolean => {
  return typeof value === 'object' && value !== null && value.constructor === Object;
}

const keyExist =  (value?: any) => {
  return value !== undefined && value !== null && value !== '';
}

const mergeObjects = <T extends object>(oldObject: PartialObject<T>, newObject: PartialObject<T>): PartialObject<T> => {

  const merged: PartialObject<any> = { ...oldObject };

  for (const [key, value] of Object.entries(newObject)) {
    if (Object.prototype.hasOwnProperty.call(merged, key)) {
      if (isPlainObject(value) && isPlainObject(merged[key])) {
        merged[key as keyof T] = mergeObjects(
          merged[key as keyof T] as PartialObject<T[keyof T]>,
          value as PartialObject<T[keyof T]>
        );
      }
      else if (keyExist(value)) {
        merged[key as keyof T] = value as PartialObject<T[keyof T]>;
      }
    }
    else if (keyExist(value)) {
      merged[key as keyof T] = value as PartialObject<T[keyof T]>;
    }
  }

  return merged;

  //  for (const key in source) {
  //   if (Object.prototype.hasOwnProperty.call(source, key)) {
  //     const sourceValue = source[key];
  //     if (sourceValue !== undefined && sourceValue !== null) {
  //       target[key] = sourceValue;
  //     }
  //   }
  // }
  // return target;

};

const convertToCamelCase = (obj: {[key: string]: string} = {}): {[key: string]: string} => {
  const result: {[key: string]: string} = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key.replace(/-(\w)/g, (_, letter) => letter.toUpperCase());
      result[newKey] = obj[key];
    }
  }
  return result;
};

export { mergeObjects, convertToCamelCase };

